import {connect} from '../../../../../redux/utils'
import {getWorkStatuses, getDefaultWorkStatusPlanningData, getInitialDefaultWorkStatus} from '../selectors'
import {bindActionCreators} from 'redux'
import TemplateView from '../../../../../TemplateView'
import ClassicBridge from '../../../../../next/ClassicBridge'
import {setEventPreventHidingEditUserSlidingPanel} from '../../../../utils'
import {MODE} from '../../../UserPanelContainer'
import {setInitialDefaultWorkStatus} from '../actions'
import {getUserDataState} from '../../../userData/selectors'


export class DefaultWorkStatusesContainer extends TemplateView {
    constructor({
        additionalClass = '',
        workStatuses = [],
        refreshScrollCb = () => {},
        mode,
        defaultWorkStatusPlanningData = () => {},
        onSetInitialDefaultWorkStatus = () => {},
        onRemoteUpdate = () => {},
    }) {
        super()
        this.additionalClass = additionalClass

        this.isShown = true
        this.mode = mode

        this.state = {
            workStatuses: workStatuses,
            defaultWorkStatusPlanningData: defaultWorkStatusPlanningData,
        }

        this.onAnyStatePropertyChanged(['defaultWorkStatusPlanningData', 'workStatuses', 'initialDefaultWorkStatus'], ({
            defaultWorkStatusPlanningData,
            initialDefaultWorkStatus,
            workStatuses
        }) => {
            this.workStatusPlanning.setProps({
                intervals: defaultWorkStatusPlanningData.items,
                actions: defaultWorkStatusPlanningData.actions,
                interval: initialDefaultWorkStatus,
                workStatuses: workStatuses,
                onChange: refreshScrollCb,
                userId: this.state.userData.userNextId,
                onInitialDefaultStatusChange: (newWorkStatusId) => {
                    onSetInitialDefaultWorkStatus({ ...initialDefaultWorkStatus, workStatusId: newWorkStatusId })
                },
                onRemoteUpdate: (intervals) => {
                    onRemoteUpdate(intervals)
                },
            })
        })
    }

    templateHtml() {
        return "<div class='workStatus'>" +
               " <div class='atNextWorkStatusPlanningMountPoint atNextMount'>" +
               "</div>"
    }

    templateModel() {
        return {
            additionalClass: this.additionalClass
        }
    }

    afterRender() {
        var $defaultWorkStatusPlanningMountPoint = this.find(".atNextWorkStatusPlanningMountPoint");
        var integratedDefaultWorkStatusPlanningEl = this.mode === MODE.EDIT
                                                    ? ClassicBridge.integrateDefaultWorkStatusPlanning($defaultWorkStatusPlanningMountPoint[0]) :
                                                    ClassicBridge.integrateInitialDefaultWorkStatus($defaultWorkStatusPlanningMountPoint[0])
        this.workStatusPlanning =  integratedDefaultWorkStatusPlanningEl
        $defaultWorkStatusPlanningMountPoint.click((e) => setEventPreventHidingEditUserSlidingPanel(e))

        this.renderInitialState()
    }

    onShow() {
        super.onShow()
        this.onShowCallback()
    }
}

export default connect(
    state => ({
        workStatuses: getWorkStatuses(state),
        defaultWorkStatusPlanningData: getDefaultWorkStatusPlanningData(state),
        initialDefaultWorkStatus: getInitialDefaultWorkStatus(state),
        userData: getUserDataState(state)
    }),
    dispatch => ({
        onShowCallback: bindActionCreators(() => {}, dispatch),
        onSetInitialDefaultWorkStatus: bindActionCreators(setInitialDefaultWorkStatus, dispatch)
    })
)(DefaultWorkStatusesContainer)



// WEBPACK FOOTER //
// ./web/js/panels/user/accountSettings/workStatuses/components/WorkStatusesContainer.js